import { render, staticRenderFns } from "./directors_en.vue?vue&type=template&id=59f4c5fe&scoped=true"
import script from "./directors_en.vue?vue&type=script&lang=js"
export * from "./directors_en.vue?vue&type=script&lang=js"
import style0 from "./directors_en.vue?vue&type=style&index=0&id=59f4c5fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4c5fe",
  null
  
)

export default component.exports